// extracted by mini-css-extract-plugin
export default {"uploadFooter":"IjxYlWfKZY1hthPFH1RD","uploadFooterLinks":"Ox6u3_Asj1AiuZe6pQ1Y","uploadFooterLink":"WUyFckotu8gccoHtlRgr","uploadFooterLogo":"_zYJdUn8X18UPEJOjk5a"};